import { Button } from "components/DesignSystem/Button/Button";
import { Header } from "components/DesignSystem/Header/Header";
import { ExportLedger } from "components/GeneralLedger/ExportLedger";
import { GeneralLedger } from "components/GeneralLedger/GeneralLedger";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { ChatTeardropDots } from "components/icons/ChatTeardropDots";
import { useModal } from "hooks/useModal";

export const GeneralLedgerApp = () => {
  const commentPane = useModal();

  return (
    <DashboardContainer className="t-h-full sm:t-h-auto sm:t-overflow-x-visible">
      <DashboardContainer.Header className="t-px-5 sm:t-px-3">
        <Header
          v2
          title="General Ledger"
          right={
            <div className="t-flex t-gap-1 t-mt-1">
              <ExportLedger size="xsmall" />
              <Button
                customType="icon"
                onClick={commentPane.toggle}
                size="xsmall"
              >
                <ChatTeardropDots />
              </Button>
            </div>
          }
        />
      </DashboardContainer.Header>

      <DashboardContainer.Content className="sm:t-overflow-visible">
        <GeneralLedger commentPane={commentPane} />
      </DashboardContainer.Content>
    </DashboardContainer>
  );
};
